import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { PurchaseOrder, PurchaseOrderItem } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'
import { SchemaUtil } from '../../utils'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class PurchaseOrderService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getPurchaseOrder(id, schema = SchemaUtil.purchaseOrder): Promise<PurchaseOrder> {
    return new PurchaseOrder(await this.core.services.purchase.getById(id, schema))
  }

  async getPurchaseOrders(
    parameters: any = {},
    schema: any = { id: null, name: null, type: null }
  ): Promise<{
    items: PurchaseOrder[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.purchase.getList(parameters, schema)
  }

  createPurchaseOrder(purchaseOrder: any, schema: any): Promise<PurchaseOrder> {
    return this.core.services.purchase.create(purchaseOrder, schema)
  }

  async updatePurchaseOrder(purchaseOrder: any, schema: any): Promise<PurchaseOrder> {
    return await this.core.services.purchase.update(purchaseOrder, schema)
  }

  deletePurchaseOrder(purchaseOrderId: any): Promise<PurchaseOrder> {
    return this.core.services.purchase.deletePurchaseOrder(purchaseOrderId)
  }

  createPurchaseOrderItem(purchaseOrderItem: Partial<PurchaseOrderItem>): Promise<PurchaseOrder> {
    return this.core.services.purchase.deletePurchaseOrderItem(purchaseOrderItem)
  }

  updatePurchaseOrderItem(purchaseOrderItem: Partial<PurchaseOrderItem>): Promise<PurchaseOrder> {
    return this.core.services.purchase.deletePurchaseOrderItem(purchaseOrderItem)
  }

  deletePurchaseOrderItem(id: number): Promise<PurchaseOrderItem> {
    return this.core.services.purchase.deletePurchaseOrder(id)
  }
}
